"use strict";

// Fonction utilitaire qui retourne une promesse qui se résout après un setTimeout avec une durée déterminée
// Ex: wait(duration en millisecondes).then(function() {
// 	do something...
// });
function wait(duration) {
	return new Promise(function(resolve) {
		setTimeout(resolve, duration);
	});
}

function debounce(callback, delay) {
	let timeout = null;

	return function() {
		clearTimeout(timeout);

		timeout = setTimeout(function() {
			callback();
		}, delay);
	};
}

/**
 *    ######## #### ##       ######## ######## ########   ######  
 *    ##        ##  ##          ##    ##       ##     ## ##    ## 
 *    ##        ##  ##          ##    ##       ##     ## ##       
 *    ######    ##  ##          ##    ######   ########   ######  
 *    ##        ##  ##          ##    ##       ##   ##         ## 
 *    ##        ##  ##          ##    ##       ##    ##  ##    ## 
 *    ##       #### ########    ##    ######## ##     ##  ######  
 */
function filterProducts(cleanUrl = true) {

	if (cleanUrl && window.location.search) {
		const cleanUrl = window.location.pathname + window.location.hash;
		window.history.replaceState({}, '', cleanUrl);
	}

	const productsContainer = $('.all-products-ctn');
	const productsWrapper = productsContainer.find('.all-products').get(0);

	if (!productsWrapper) return;

	const searchTerm = $('#search-input').val().toLowerCase().trim();
	const activeFilters = getActiveFilters();

	productsContainer.addClass('--loading');
	productsWrapper.classList.add('--transitioning');

	wait(600).then(function() {
		animateProductsContainerHeight(function() {

			let visibleProductsCount = 0;
			const hasActiveFilters = Object.keys(activeFilters).length > 0;

			$('.products-grid .product-card').each(function() {
				const product = this;
				const title = $(product).find('.title').text().toLowerCase();

				const searchMatch =
					searchTerm === '' ||
					title.includes(searchTerm);

				let categoryMatch = true;

				if (hasActiveFilters) {
					categoryMatch = Object.entries(activeFilters).some(function([filterName, selectedValues]) {
						const productValues = (product.dataset[filterName] || '')
							.split(',')
							.filter(Boolean);

						return selectedValues.some(value => productValues.includes(value));
					});
				}

				const isVisible = searchMatch && categoryMatch;

				if (isVisible) {
					product.classList.remove('--hidden');
					visibleProductsCount++;
				} else {
					product.classList.add('--hidden');
				}
			});

			const productsGrid = $('.products-grid');

			if (visibleProductsCount === 0) {
				productsGrid.addClass('--hidden');
				$('.no-products').addClass('--is-visible');
			} else {
				productsGrid.removeClass('--hidden');
				$('.no-products').removeClass('--is-visible');
			}
		});
	});

	wait(1200).then(function() {
		productsContainer.removeClass('--loading');
		productsWrapper.classList.remove('--transitioning');
	});
}

function getActiveFilters() {
	const filters = {};

	$('.module-categories-filters .checkbox-group input:checked').each(function() {
		const filterName = this.dataset.filter;
		const filterValue = this.value;

		if (!filterName || !filterValue || filterValue === 'all') {
			return;
		}

		if (!filters[filterName]) {
			filters[filterName] = [];
		}

		filters[filterName].push(filterValue);
	});

	return filters;
}

function initCategoryFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const category = params.get('category')?.toLowerCase();

    const categoryMap = {
        fleurs: 'category_01',
        plantes: 'category_02',
        cadeaux: 'category_03',
        occasions: 'category_04'
    };

    const filterName = categoryMap[category];

    if (!filterName) return;

    const categoryGroup = $(`.category-group[data-category="${filterName}"]`);

    if (!categoryGroup.length) return;

    categoryGroup.find('input[type="checkbox"]').prop('checked', true);

    categoryGroup.addClass('--is-open');

    filterProducts(false);
}

// Animation de la hauteur du conteneur des produits
function animateProductsContainerHeight(callback) {
	const container = document.querySelector('.all-products-ctn');
	const content = document.querySelector('.all-products');

	if (!container || !content) {
		if (typeof callback === 'function') callback();
		return;
	}

	// Nettoie une transition précédente
	container.style.transition = 'none';
	container.style.height = container.offsetHeight + 'px';

	// Force repaint
	container.offsetHeight;

	// Remet la transition
	container.style.transition = 'height 0.4s ease';

	if (typeof callback === 'function') callback();

	const endHeight = content.scrollHeight;

	requestAnimationFrame(function() {
		container.style.height = endHeight + 'px';
	});

	const onTransitionEnd = function(event) {
		if (event.propertyName !== 'height') return;

		container.style.height = 'auto';
		container.removeEventListener('transitionend', onTransitionEnd);
	};

	container.addEventListener('transitionend', onTransitionEnd);

	wait(1200).then(function() {
		container.style.height = 'auto';
	});
}

const debouncedFilterProducts = debounce(function() {
	filterProducts();
}, 300);

/**
 *                                                                                                                            
 *     ###### # #      ##### ###### #####     #####  #   #     ####    ##   ##### ######  ####   ####  #####  # ######  ####  
 *     #      # #        #   #      #    #    #    #  # #     #    #  #  #    #   #      #    # #    # #    # # #      #      
 *     #####  # #        #   #####  #    #    #####    #      #      #    #   #   #####  #      #    # #    # # #####   ####  
 *     #      # #        #   #      #####     #    #   #      #      ######   #   #      #  ### #    # #####  # #           # 
 *     #      # #        #   #      #   #     #    #   #      #    # #    #   #   #      #    # #    # #   #  # #      #    # 
 *     #      # ######   #   ###### #    #    #####    #       ####  #    #   #   ######  ####   ####  #    # # ######  ####  
 *                                                                                                                            
 */
$('.module-categories-filters .checkbox-group input').on('change', filterProducts);
$('#search-input').on('keyup', debouncedFilterProducts);

$(document).ready(function() {
	const categoriesFilter = $('.module-categories-filters');
	const firstFilter = $(categoriesFilter).find('.category-group').get(0);
	firstFilter.classList.add('--is-open');

    /**
 	*                                              
	*     #####  ####   ####   ####  #      ###### 
	*       #   #    # #    # #    # #      #      
	*       #   #    # #      #      #      #####  
	*       #   #    # #  ### #  ### #      #      
	*       #   #    # #    # #    # #      #      
	*       #    ####   ####   ####  ###### ###### 
	*                                              
	*/
	// Module tiroir des filtres
	const toggleElements = ['.open-filters', '.module-categories-filters .header', '.filters-backdrop'];
	toggleElements.forEach(element => {
		document.querySelector(element).addEventListener('click', () => {
			 $(categoriesFilter).toggleClass("--is-open");
		});
	});
 
	// Accordéons des filtres avec leurs options
	$('.category-header').on("click", function() {
		const category = $(this).closest('.category-group');
		$(category).toggleClass('--is-open');
	})

	initCategoryFromUrl();
});